<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :types="['com_name', 'field_name', 'date',]"
      :mobile-types="['field_name']"
      :typeslabel="{
        com_name: '회사명',
      }"
    />

    <!--    회의내용-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>{{ $t('회의내용') }}</h5>
      <div class="writeGridContainer">
        <div>
          <div>{{ $t('회의일') }}</div>
          <p v-if="isPrint">{{ form.inputA_1 }}</p>
          <div v-else class="flex-1 flex items-center">
            <date-selector v-model="form.inputA_1" />
            <p class="px-2">~</p>
            <date-selector v-model="form.inputA_2" />
          </div>
        </div>
        <div>
          <div>{{ $t('회의 총 인원') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_3 }}</p>
          <ml-input v-else v-model="form.inputA_3" :readonly="board.readonly" type="number"/>
        </div>
        <div>
          <div>{{ $t('회의 참여 인원') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_4 }}</p>
          <ml-input v-else v-model="form.inputA_4" :readonly="board.readonly" type="number"/>
        </div>

        <div>
          <div>{{ $t('회의 참여 인원') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_5 }}</p>
          <ml-input v-else v-model="form.inputA_5" :readonly="board.readonly" />
        </div>
        <div>
          <div>{{ $t('교육자') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_6 }}</p>
          <ml-input v-else v-model="form.inputA_6" :readonly="board.readonly" />
        </div>

        <div class="writeGridLineItem">
          <div>{{ $t('회의내용') }}</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputA_7 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputA_7" :readonly="board.readonly" placeholder="- 『위험성평가』실시 결과(잔류 위험성)에 따른 조치의 내용
- 『위험성평가』추가 감소대책 수립 및 실행에 대한 내용 等
-  교육자료
  · 위험성평가 결과 및 대책
  · 공사관리 매뉴얼 및 작업 SOP"/>
        </div>
      </div>
    </div>

    <!--    사진대지-->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="교육사진"
    />

    <!-- 참석자 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="참석자"
      :tableData="[
        { id: 'input1', title: '소속', type: 'text' },
        { id: 'input2', title: '직책', type: 'text' },
        { id: 'input3', title: '성명', type: 'text' },
        { id: 'sign', title: '서명', type: 'sign' },
        { id: 'input4', title: '비고', type: 'text' },
      ]"
      :mobile="['input1', 'input3']"
      v-model="form.participants"
      class="mt-28px"
    />


    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableEquipment from "@/components/TableEquipment";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import MeasureStateSelector from "@/components/selector/MeasureStateSelector";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import SignField from "@/components/SignField.vue";
import TableCustom from "@/components/TableCustom.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";

export default {
  components: {
    TimeSelector,
    TableCustom,
    SignField,
    PhotoUploadGridModule,
    FieldSelectModule,
    MeasureStateSelector,
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
        inputA_7: "",

        participants: [],

        photoList: [],
        fileList: [],
      },
    };
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
